import React from "react";
import LayoutHeader from "./Header";
import { useLocation } from "react-router-dom";
// import { trackMarkedPerformance } from "../../utils/performance_report";
import { reportPerformanceMetric } from "../../utils/performance";
import "./BasicLayout.less";

type BasicLayoutConfig = {
  content: JSX.Element;
  title: string;
  hideHeader: boolean;
  bgColor: string;
  iconUrl: string;
  linkUrl: string;
};

// 通用标题头
export default function BasicLayout(props: Partial<BasicLayoutConfig>): JSX.Element {
  const location = useLocation();

  React.useEffect(() => {
    if (location.pathname) reportPerformanceMetric("V1_P4");
  }, [location.pathname]);

  return (
    <div className="basic-layout">
      {props.hideHeader ? null : (
        <div className="layout-header" style={{ background: props.bgColor }}>
          <LayoutHeader
            title={props.title || ""}
            iconUrl={props.iconUrl || ""}
            linkUrl={props.linkUrl || ""}
          />
        </div>
      )}
      <div className="layout-body">{props.content}</div>
    </div>
  );
}
